import * as borogove from "borogove";
import encodeQR from "qr";
import { useOutletContext } from "react-router";
import { ChatContainer, MessageList } from "@chatscope/chat-ui-kit-react";
import { AvatarWithPlaceholder } from "./AvatarWithPlaceholder";

export const Account = () => {
	const { active, client, status, setStatus } = useOutletContext<{
		active: boolean;
		client: borogove.Client;
		status: string;
		setStatus: (status: string) => void;
	}>();
	const self = client
		.getChat(client.accountId())
		?.getParticipantDetails(client.accountId());

	return (
		<ChatContainer className={active ? "active" : undefined}>
			<MessageList className="account">
				<MessageList.Content>
					<h1>Account Details</h1>
					<code>{client.accountId()}</code>

					<AvatarWithPlaceholder
						displayName={client.displayName()}
						placeholderUri={self?.placeholderUri}
						photoUri={self?.photoUri}
					/>

					<form
						onSubmit={(e) => {
							e.preventDefault();
							client.setDisplayName(e.currentTarget.fn.value);
						}}
					>
						<input
							key={"nicknameWithDefault" + client.displayName()}
							type="text"
							name="fn"
							autoComplete="nickname"
							defaultValue={client.displayName()}
						/>
						<button>Save</button>
					</form>

					{status === "auth" && (
						<form
							onSubmit={(e) => {
								e.preventDefault();
								client.usePassword(e.currentTarget.password.value);
								setStatus("connecting");
							}}
						>
							Please enter your password again:
							<input type="password" name="password" />
							<button>Login</button>
						</form>
					)}

					<div
						className="qrcode"
						dangerouslySetInnerHTML={{
							__html: encodeQR(
								"xmpp:" + encodeURIComponent(client.accountId()),
								"svg",
								{ ecc: "high" },
							),
						}}
					/>
				</MessageList.Content>
			</MessageList>
		</ChatContainer>
	);
};
